module.exports = __webpack_public_path__ + "static/media/avatar-9.190880e3.svg";